import fileSelector from '../app/file_selector';

$(document).on('ready turbolinks:load', () => {
  fileSelector({
    uploadButton: $('#client-logo'),
    idInput: $('input#client_logo_resource_id'),
    type: 'logos',
    button: $('button#save-client-button'),
  });
});
